<!-- eslint-disable vue/no-unused-components -->
<!-- eslint-disable vue/no-multiple-template-root -->
 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

<script>

import abstractComponent from "../components/help/abstractComponent.vue";
import arrayListComponent from "../components/help/arrayListComponent.vue";
import arraysComponent from "./help/arraysComponent.vue";
import classCastExceptionComponent from "../components/help/classCastExceptionComponent.vue";
import constructorWritingComponent from "../components/help/constructorWritingComponent.vue";
import dateComponent from "../components/help/dateComponent.vue";
import extendsComponent from "../components/help/extendsComponent.vue";
import functionCallingWithObjectComponent from "../components/help/functionCallingWithObjectComponent.vue";
import getterComponent from "../components/help/getterComponent.vue";
import interfaceComponent from "../components/help/interfaceComponent.vue";
import newVariableComponent from "../components/help/newVariableComponent.vue";
import nullPointerExceptionComponent from "../components/help/nullPointerExceptionComponent.vue";
import objectCreationComponent from "../components/help/objectCreationComponent.vue";
import parseExceptionComponent from "../components/help/parseExceptionComponent.vue";
import passingArgumentsToFunctionsComponent from "../components/help/passingArgumentsToFunctionsComponent.vue";
import printFunctionComponent from "../components/help/printFunctionComponent.vue";
import setterComponent from "../components/help/setterComponent.vue";
import stringCompareComponent from "../components/help/StringcompareComponent.vue";
import superKeywordComponent from "../components/help/superKeywordComponent.vue";
import thisComponent from "../components/help/thisComponent.vue";
import tryCatchComponent from "../components/help/tryCatchComponent.vue";


export default {
  components: {
    abstractComponent,
    arrayListComponent,
    arraysComponent,
    classCastExceptionComponent,
    constructorWritingComponent,
    dateComponent,
    extendsComponent,
    functionCallingWithObjectComponent,
    getterComponent,
    interfaceComponent,
    newVariableComponent,
    nullPointerExceptionComponent,
    objectCreationComponent,
    parseExceptionComponent,
    passingArgumentsToFunctionsComponent,
    printFunctionComponent,
    setterComponent,
    stringCompareComponent,
    superKeywordComponent,
    thisComponent,
    tryCatchComponent,
  },
  methods: {
    popup(chosenComponent) {
      this.currentComponent = chosenComponent;
      console.log("popup")
      var modal = document.getElementById("myModal");
      console.log(modal)
      var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";
        console.log(modal.style.display)
      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = "none";
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    },
    correct1() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Correct";
      x.style.backgroundColor = "green";
      x.className = "show";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000)
    },
    incorrect() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Inorrect. Try again";
      x.style.backgroundColor = "red";
      x.className = "show";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000)
    },
    validate_one() {
      console.log(this.one, this.two);
      if (this.one == "WeekEndDecorator" && this.two == "HiringVehicle") {
        this.correct1();
        this.display[0] = "none";
        this.display[1] = "block";
      } else {
        this.incorrect();
      }
    },

    validate_two() {
      if (this.three == "AfterNoonDecorator" && this.four == "HiringVehicle") {
        this.correct1();
        this.display[1] = "none";
        this.display[2] = "block";
        this.$emit('testDriver', true);
      } else {
        this.incorrect();
      }
    },

    
  },
  data() {
    return {
      id: 'container',
      class: 'wrapper',
      button_value: 'Next',
      currentComponent: 'constructorWritingComponent',
      button_text: "Incorrect. Try again",
      button_text_right: "Correct. Next",
      correct: false,
      display: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none",]
    }
  }

}

</script>
<template>
  <main class="app">
    <div id="snackbar">Some text some message..</div>

    <div class="column" style="position:sticky; top: 30%; left: 65%; bottom: 10%; float: right">
      <div class="column">
        <div class="codebox">
          <h5>Test Driver: </h5>
          <ul style="line-height: 125%;">
            <li>Write a TestDriver class that contains an object of type RentalSystem.</li>
             <li>Create an array 'execobj' that can hold one object of type Exec.</li>
             <li>Initialize execobj[0] with name as 'EFG', email as 'efg@gmail.com' and city as 'Coimbatore' using the PersonBuilder class. </li>
             <li>Create an array 'cobj' that can hold three objects of type Customer.</li>
             <li>Initialize cobj[0] with name as "ABC", email as "abc@gmail.com" and city as "Coimbatore" using the PersonBuilder class.</li>
             <li>Initialize cobj[0] with name as "GHI", email as "ghi@gmail.com", phone as 1234567890 and city as "Chennai" using the PersonBuilder class.</li>
             <li>Create an array vobj that can hold two objects of type Vehicle.</li>
             <li>Use WeekEndDecorator to initialize vobj[0] with the appropriate parameters. RegNum is 1234 and hireRatePerDay is 3000.</li>
             <li>Use PeakSeasonDecorator to initialize vobj[1] with the appropriate parameters. RegNum is 3456 and hireRatePerDay is 2500.</li>
             <li>Create an array 'robj' that can hold one object of type Reservation.</li>
             <li>Initialize robj[0] with an object of type Reservation passing the appropriate Customer and Vehicle objects as parameters.</li>
             <li>Call the visitOffice method with the appropriate parameter.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">

      <div class="column">
        <h1 style="padding: 25px; padding-bottom: 0px;">Understanding Decorator Usage - Test Driver Construction</h1>
        <p style="padding: 25px; padding-top: 0px">Use the WeekEndDecorator and PeakSeasonDecorator decorators to initialise the vehicle objects reqiured for the reservation method and call the visitOffice method</p>

        <div class="codebox" id="codebox" :style="{ display: display[0] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[2];

</pre>
&emsp;&emsp;&emsp;rentalSystem.vobj[0] = new <input type="text" v-model="one" style="width: 150px" maxlength="16">(new <input spellcheck="false" style="width: 130px;" id="two" v-model="two" maxlength="13">(1234,3000));<br>
<p id="comment">//Call the WeekEndDecorator and pass as parameter a hiring vehicle object with RegNum as 1234 and hireRatePerDay as 3000</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_one()"> {{ button_value }}</button>
        </div>

        
        <div class="codebox" id="codebox" :style="{ display: display[1] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[2];
    rentalSystem.vobj[0]=new WeekEndDecorator(new HiringVehicle(1234,3000));

</pre>
&emsp;&emsp;&emsp;rentalSystem.vobj[1] = new PeakSeasonDecorator(new <input type="text" v-model="three" style="width: 150px" maxlength="18">(new <input spellcheck="false" style="width: 130px;" id="four" v-model="four" maxlength="13">(3456,2500));<br>
<p id="comment">//Initialise vobj[1] with a PeakSeasonDecorator with parameter as HiringVehicle object with RegNum as 3456 and hireRatePerDay as 2500</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_two()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[2] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[2];
    rentalSystem.vobj[0]=new WeekEndDecorator(new HiringVehicle(1234,3000));

    rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation(rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
    Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		System.out.println("Hiring rate of the vehicle " + rentalSystem.vobj[0].getRegNum() + " is " 
        +rentalSystem.vobj[0].getHireRatePerDay());
		System.out.println("Hiring rate of the vehicle " + rentalSystem.vobj[1].getRegNum() + " is " 
        +rentalSystem.vobj[1].getHireRatePerDay());
				
		rentalSystem.visitOffice(rentalSystem.robj[0]);
	}	
}
</pre>
        </div>

       </div>
    </div>
  </main>
</template>

<style scoped>
* {
  box-sizing: border-box;
  background-color: #F9FAFE;
}

h1,
h2,
p {
  font-family: sans-serif;
  color: rgb(0, 3, 40);
}

.column {
  float: left;
  width: 50%;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}


mark1 {
  background-color: rgb(176, 230, 183);
  box-shadow: 1px 6px 15px 2px rgb(160, 222, 159);
  color: black;
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
}

mark0 {
  box-shadow: 1px 6px 15px 2px rgb(249, 255, 191);
  background-color: rgb(231, 238, 162);
  color: black;
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
}

#comment {
  margin-left: 15px;
  font-style: italic;
  color: gray;
  font-size: small;
}


.codebox {
  height: 80%;
  width: fit-content;
  min-width: 90%;
  margin: 25px;
  padding: 25px;
  border-radius: 10px;
  background-color: #F9FAFE;
  box-shadow: 2px 3px 10px 2px #D7DFFF;
}

input {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  color: black;
}

/* CSS */
.button-9 {
  appearance: button;
  backface-visibility: hidden;
  background-color: #405cf5;
  border-radius: 6px;
  border-width: 0;
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .1) 0 2px 5px 0, rgba(0, 0, 0, .07) 0 1px 1px 0;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  font-family: -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif;
  font-size: 100%;
  height: 44px;
  line-height: 1.15;
  margin: 12px 0 0;
  outline: none;
  overflow: hidden;
  padding: 0 25px;
  position: relative;
  text-align: center;
  text-transform: none;
  transform: translateZ(0);
  transition: all .2s, box-shadow .08s ease-in;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 200px;
}

.button-9:disabled {
  cursor: default;
}

.button-9:focus {
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .2) 0 6px 15px 0, rgba(0, 0, 0, .1) 0 2px 2px 0, rgba(50, 151, 211, .3) 0 0 0 4px;
}

#snackbar {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
</style>
 